import { useCore } from '$api-clients/hooks';
import {
  buildLastViewedText,
  getHref,
  isInternalLink,
  shouldOpenInNewTab,
} from './helpers';

export function useLastViewed() {
  const { data, isLoading: loading } = useCore('/users/me/location-history');

  return {
    loading,
    lastViewed: data?.url
      ? {
          dateTime: buildLastViewedText(data.dateTime),
          href: getHref(data.url),
          title: data.title,
          description: data.description,
          isInternalLink: isInternalLink(data.url),
          fullRoute: data.url,
          shouldOpenInNewTab: shouldOpenInNewTab(data.url),
        }
      : null,
  };
}
